import { Link } from "react-router-dom";

const stats = [
  { value: "12年", label: "专注甜品研发" },
  { value: "60+", label: "全球合作门店" },
  { value: "800万", label: "累计用户喜爱" },
];

export default function HeroSection() {
  return (
    <section className="relative w-full h-[560px] md:h-[680px] overflow-hidden flex items-center">
      <img
        src="https://readdy.ai/api/search-image?query=Dreamy%20stylized%20candy%20and%20dessert%20world%20scene%20with%20warm%20coral%20orange%20and%20pink%20tones%2C%20flowing%20soft%20shapes%20of%20strawberry%20gummies%20and%20cookies%2C%20artistic%20abstract%20composition%2C%20premium%20brand%20key%20visual%2C%20soft%20lighting%2C%20high%20detail%2C%20elegant%20sweet%20atmosphere&width=1920&height=1080&seq=tx-home-hero&orientation=landscape"
        alt="糖心VLGO 品牌主视觉"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/45 to-foreground-950/70"></div>

      <div className="relative z-10 w-full px-4 md:px-10 pt-24">
        <div className="max-w-3xl animate-fade-up">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-xs font-medium tracking-wide">
            <i className="ri-heart-3-fill text-accent-400 leading-none"></i>
            官方品牌官网 · 甜蜜生活方式
          </span>
          <h1 className="mt-6 font-heading text-4xl md:text-6xl font-extrabold text-background-50 leading-tight tracking-tight">
            真实一点，
            <br />
            甜一点。
          </h1>
          <p className="mt-6 max-w-xl text-base md:text-lg text-background-50/85 leading-relaxed">
            糖心VLGO 相信每一份甜都值得被认真对待。我们坚持真实用料、少糖配方与用心工艺，
            把自然的果香与温柔的心意，装进你手里的每一颗糖。
          </p>
          <div className="mt-9 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <Link
              to="/about"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold whitespace-nowrap cursor-pointer transition-colors hover:bg-primary-600"
            >
              了解更多
              <i className="ri-arrow-right-line leading-none"></i>
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold whitespace-nowrap cursor-pointer transition-colors hover:bg-background-50/20"
            >
              <i className="ri-newspaper-line leading-none"></i>
              浏览产品资讯
            </Link>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-3 gap-4 max-w-xl">
          {stats.map((s) => (
            <div key={s.label} className="text-background-50">
              <div className="font-heading text-2xl md:text-3xl font-extrabold text-accent-400">
                {s.value}
              </div>
              <div className="mt-1 text-xs md:text-sm text-background-50/75">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}